// extracted by mini-css-extract-plugin
export default {"analytics":"analytics--WFXj6"};